import { Loader2, Sparkles, ArrowRight } from "lucide-react";

const fmtSupply = (n) => Number(n || 0).toLocaleString();

export default function StepLogo({ coin, logoUrl, logoBusy, aiError, genLogo, uploadLogo, next, back }) {
  return (
    <div data-testid="step-1">
      <h1 className="font-display font-black text-4xl sm:text-5xl uppercase tracking-tighter mb-3">
        Mint a logo with AI.
      </h1>
      <p className="text-[#e2e2e2] mb-8">
        We use Gemini Nano Banana. Click generate. Re-roll if you don&apos;t love it.
      </p>

      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 sm:col-span-5">
          <div
            className="aspect-square border border-[#3a3a3a] bg-[#121212] flex items-center justify-center overflow-hidden"
            data-testid="logo-preview"
          >
            {logoUrl ? (
              <img src={logoUrl} alt="logo" className="w-full h-full object-cover" />
            ) : logoBusy ? (
              <Loader2 size={32} className="animate-spin text-[#cfff04]" />
            ) : (
              <div className="text-center text-[#d0d0d0] font-mono text-xs uppercase tracking-widest px-6">
                No logo yet. Hit generate.
              </div>
            )}
          </div>
        </div>
        <div className="col-span-12 sm:col-span-7 space-y-4">
          <div className="border border-[#3a3a3a] bg-[#121212] p-5">
            <div className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] mb-2">
              Coin
            </div>
            <div className="font-display text-2xl font-bold">
              {coin.name} <span className="text-[#cfff04]">${coin.ticker}</span>
            </div>
            <div className="text-sm text-[#e2e2e2] mt-1">
              {fmtSupply(coin.supply)} supply · theme: {coin.theme}
            </div>
          </div>

          <button
            onClick={genLogo}
            disabled={logoBusy}
            data-testid="gen-logo"
            className="w-full btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-sm py-4 flex items-center justify-center gap-2"
          >
            {logoBusy ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
            {logoUrl ? "Regenerate with AI" : "Generate with AI"}
          </button>

          <div className="relative flex items-center gap-3" data-testid="logo-divider">
            <div className="flex-1 h-px bg-[#222]" />
            <span className="font-mono text-xs text-[#d0d0d0] uppercase tracking-widest">or</span>
            <div className="flex-1 h-px bg-[#222]" />
          </div>

          <label
            htmlFor="logo-upload"
            data-testid="upload-logo-label"
            className="w-full block cursor-pointer border-2 border-dashed border-[#333] hover:border-[#cfff04] hover:bg-[#121212] transition-colors text-center py-4 px-4"
          >
            <div className="font-mono text-xs uppercase tracking-widest text-[#cfff04]">
              ↑ Upload your own logo
            </div>
            <div className="text-sm text-[#c4c4c4] mt-1">
              PNG · JPG · WEBP · GIF · max 3 MB
            </div>
          </label>
          <input
            id="logo-upload"
            type="file"
            accept="image/png,image/jpeg,image/webp,image/gif"
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) uploadLogo(f);
              e.target.value = ""; // allow re-uploading same file
            }}
            data-testid="upload-logo-input"
            className="sr-only"
          />

          <p className="font-mono text-xs text-[#d0d0d0] uppercase tracking-widest">
            // 1024×1024 PNG · ~15s · 1 credit
          </p>
        </div>
      </div>

      {aiError && (
        <div
          data-testid="ai-error-banner"
          className="mt-6 border border-yellow-700/40 bg-yellow-900/10 p-4 text-sm leading-relaxed text-yellow-200"
        >
          {aiError}
        </div>
      )}

      <div className="mt-8 flex items-center justify-between gap-3">
        <button onClick={back} className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] hover:text-white" data-testid="step-back">
          ← Back
        </button>
        <div className="flex items-center gap-3">
          {!logoUrl && (
            <button
              type="button"
              onClick={next}
              data-testid="skip-logo"
              className="font-mono text-xs uppercase tracking-widest text-[#e2e2e2] hover:text-white px-4 py-3"
            >
              Skip →
            </button>
          )}
          <button
            onClick={next}
            data-testid="create-next"
            className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-sm px-8 py-4 flex items-center gap-2"
          >
            <ArrowRight size={16} />
            Next: Whitepaper
          </button>
        </div>
      </div>
    </div>
  );
}
